// Dependencies
import React from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';

import BackImage from 'components/BackImage';
import Header from 'components/Header';
import CheckLogin from 'components/LoginForm/CheckLogin';
import MobileWarning from 'components/MobileWarning';
import WebsiteSplitter from 'components/WebsiteSplitter';
import BadgeView from 'views/BadgeView';
import { CollectionView } from 'views/CollectionView/CollectionView';
import { ContactView } from 'views/ContactView';
import DirectoryView from 'views/DirectoryView/DirectoryView';
import DiplomaView from 'views/DiplomaView';
import FavoriteView from 'views/FavoriteView';
import HomeView from 'views/HomeView';
import NotFoundView from 'views/NotFoundView';
import NotLoggedInView from 'views/NotLoggedInView';
import RetainContentView from 'views/RetainContentView';
import RetainView from 'views/RetainView';
import RewardsView from 'views/RewardsView';
import ShowcaseCollectionView from 'views/ShowcaseCollectionView';
import SubAppView from 'views/SubAppView';
import TemplateView from 'views/TemplateView';
import ThankYouView from 'views/ThankYouView';
import ToolboxView from 'views/ToolboxView';
import TrainingContentView from 'views/TrainingContentView';
import TrainingView from 'views/TrainingView';
import { FastTrackContentView } from 'views/FastTrackContentView/FastTrackContentView';
import { default as BookingFormView } from 'views/BookingFormView';
import { default as DashboardView } from 'views/DashboardView';
import { default as TermsAndConditionsView } from 'views/TermsAndConditionsView';
import { FastFactsView } from 'views/FastFactsView/FastFactsView';
import { ProfileImageView } from 'views/ProfileImageView/ProfileImageView';
import { useFeatureFlag } from 'hooks/useFeatureFlag';

const loginPages = ['training', 'retain', 'rewards', 'sell', 'profile-image', 'diploma'];
const paths = `(${loginPages.join('|')})`;

const SubRouter = () => {
  const fastTrackEnabled = useFeatureFlag('enable_fast_track');

  return (
    <div className="subRouter" id="container">
      <Route exact path="/main" render={(routerProps) => <CheckLogin pathname={routerProps.location.pathname} />} />
      <Route
        path={`/main/${paths}`}
        render={(routerProps) => <CheckLogin pathname={routerProps.location.pathname} />}
      />
      <Route path="/main/" render={(routerProps) => <Header pathname={routerProps.location.pathname} />} />
      <div className="viewContainer" data-testid="view-container">
        <BackImage key={window.location.pathname} darken />
        <Switch>
          <Route path="/main" exact component={HomeView} />
          <Route path="/main/rewards" exact component={RewardsView} />
          <Route path="/main/rewards/achievements" exact component={BadgeView} />
          <Route path="/main/rewards/dashboard" exact component={DashboardView} />
          <Route path="/main/rewards/form" exact component={BookingFormView} />
          <Route path="/main/rewards/thank-you" exact component={ThankYouView} />
          <Route path="/main/rewards/terms" exact component={TermsAndConditionsView} />
          <Route path="/main/landing" exact component={HomeView} />
          {/* <Route path="/main/hotel-showroom/:category/:countryName" component={ShowcaseCollectionCountryView} /> */}
          <Route path="/main/hotel-showroom/:category" component={ShowcaseCollectionView} />
          <Route path="/main/mob" exact component={MobileWarning} />
          <Route path="/main/contact" exact component={ContactView} />
          <Route path="/main/favorites/contact" exact component={ContactView} />
          <Route path="/main/(training|retain|ret)/contact" exact component={ContactView} />
          <Route path="/main/(sell|promote)/contact" exact component={ContactView} />
          <Route path="/main/sell/templates" exact component={TemplateView} />
          <Route path="/main/sell/templates-mobile" exact component={TemplateView} />
          <Route path="/main/training" exact component={TrainingView} />
          <Route path="/main/diploma" exact component={DiplomaView} />
          <Route path="/main/ret" exact component={RetainView} />
          <Route path="/main/ret/chapter" exact render={() => <Redirect to="/main/ret" />} />
          <Route path="/main/retain" exact component={RetainView} />
          <Route path="/main/ret/chapter/:chapterId/:pageId" exact component={RetainContentView} />
          <Route
            path="/main/:pageType/chapter/:chapterId/:pageId"
            render={(props) => {
              const { pageType, pageId } = props.match.params;
              switch (pageType) {
                case 'ret':
                  return <RetainContentView key={pageId} {...props} />;
                case 'fasttrack':
                  if (fastTrackEnabled === null) return null;
                  return fastTrackEnabled ? (
                    <FastTrackContentView key={pageId} {...props} />
                  ) : (
                    <Redirect to="/main/training" />
                  );
                case 'training':
                  return (
                    <TrainingContentView
                      key={pageId}
                      redirPath={`/main/${pageType}/chapter/`}
                      type={pageType}
                      {...props}
                    />
                  );
                default:
                  return null;
              }
            }}
          />
          <Route path="/main/favorites" exact component={FavoriteView} />
          <Route path="/main/promote" exact component={FastFactsView} />
          <Route path="/main/sell" exact component={ToolboxView} />
          <Route path="/main/subApp" exact component={SubAppView} />
          <Route path="/main/directory" exact component={DirectoryView} />
          <Route path="/main/sell/directory" exact component={DirectoryView} />
          <Route path="/main/showcases" exact component={ShowcaseCollectionView} />
          <Route path="/main/profile-image" exact component={ProfileImageView} />
          <Route path="/main/:category" exact component={CollectionView} />
          <Route path="/main/favorites/:category" exact component={CollectionView} />
          <Route path="/main/(training|retain|ret)/:category" exact component={CollectionView} />
          <Route path="/main/promote/videos/:videoId?" component={CollectionView} />
          <Route path="/main/promote/images/:imageId?" component={CollectionView} />
          <Route path="/main/sell/videoLibrary/:videoId?" component={CollectionView} />
          <Route path="/main/sell/imageLibrary/:imageId?" component={CollectionView} />
          <Route path="/main/(sell|promote)/:category/:item?" component={CollectionView} />
          <Route path="/main/offers/:item?" component={CollectionView} />
          <Route path="/main/off" component={NotLoggedInView} />
          <Route path="/main/splitter/:itemId/:type" component={WebsiteSplitter} />
          <Route component={NotFoundView} />
        </Switch>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default withRouter(SubRouter);
